import { getOverviewCategories } from './getOverviewCategories';
import { getOverview } from './getOverview';
import { getIconsSummary } from './getIconsSummary';
import { getIconsAll } from './getIconsAll';

export const categoryService = {
  getOverviewCategories,
  getOverview,
  getIconsSummary,
  getIconsAll,
};
